import CompanyBrainAutomations from "./company-brain-automations"

export default function Proactiveness() {
	return (
		<div className="flex flex-col gap-6">
			<CompanyBrainAutomations />
		</div>
	)
}
